<form [formGroup]="formData">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="">LWA Client Id</label>
        <input type="text" class="text lum-input" formControlName="lwaClientId" />
      </div>
      <div class="form-group">
        <label for="">LWA Client Secret</label>
        <input
          type="text"
          class="text lum-input"
          formControlName="lwaClientSecret"
        />
      </div>
      <div class="form-group">
        <label for="">LWA Refresh Token</label>
        <input
          type="text"
          class="text lum-input"
          formControlName="lwaRefreshToken"
        />
      </div>
      <div class="form-group">
        <label for="">AWS Access Key Id</label>
        <input
          type="text"
          class="text lum-input"
          formControlName="awsAccessKeyId"
        />
      </div>
      <div class="form-group">
        <label for="">AWS Secret Access Key</label>
        <input
          type="text"
          class="text lum-input"
          formControlName="awsSecretAccessKey"
        />
      </div>
      <div class="form-group">
        <label for="">Role ARN</label>
        <input type="text" class="text lum-input" formControlName="roleArn" />
      </div>
    </div>
  </div>
</form>
